export type { IMultiselectOptions as ISelectOptions } from './multiselect';

export { default } from './multiselect';
